import type { ReactNode } from "react"

type EmptyStateProps = {
  /** Qué falta, en una frase: "No hay cursos con ese criterio." */
  message: string
  /** Siguiente paso posible (botón o enlace), si lo hay. */
  action?: ReactNode
  className?: string
}

/**
 * Estado vacío único: mismo contraste y mismo `role="status"` que LoadState, con espacio para
 * una acción sugerida. `DataTable` lo usa para `emptyMessage`.
 */
export function EmptyState({ message, action, className = "" }: EmptyStateProps) {
  return (
    <div role="status" aria-live="polite" className={`flex flex-col items-center gap-3 px-4 py-8 text-center text-sm text-gray-500 dark:text-gray-400 ${className}`}>
      <p>{message}</p>
      {action ? <div>{action}</div> : null}
    </div>
  )
}

export default EmptyState
